exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hello {\n  color: rgb(0, 255, 21);\n}\n", ""]);

// exports
